import { PanelAPI } from '@philips-emr/tws-components';
import { Breakpoint } from '@philips-emr/tws-constants';
import { FetchEvent } from '@philips-emr/tws-core/lib/component/types';
import { getBreakpoint } from '@philips-emr/tws-utils';

function setVisibility(event: FetchEvent, api?: PanelAPI): void {
  const { data } = event;
  if (data) {
    if (!Object.keys(data).length) {
      api && api.setVisible(false);
    }
  }
}

function shouldRenderMobile(): boolean {
  const breakpoint = getBreakpoint();
  return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
}

export {
  setVisibility,
  shouldRenderMobile,
};
